import logo_engie from "../assets/images/suppliers/engie.png?url";
import logo_luminus from "../assets/images/suppliers/luminus.png?url";
import logo_eneco from "../assets/images/suppliers/eneco.png?url";
import logo_total_energies from "../assets/images/suppliers/total_energies.png?url";
import logo_mega from "../assets/images/suppliers/mega.png?url";
import logo_elegant from "../assets/images/suppliers/elegant.png?url";
import logo_energiebe from "../assets/images/suppliers/energiebe.png?url";
import logo_ecopower from "../assets/images/suppliers/ecopower.png?url";
import logo_cociter from "../assets/images/suppliers/cociter.png?url";
import logo_bolt from "../assets/images/suppliers/bolt.png?url";
import logo_octaplus from "../assets/images/suppliers/octaplus.png?url";
import logo_dats24 from "../assets/images/suppliers/dats24.png?url";

export enum Providers {
  engie,
  luminus,
  eneco,
  total,
  mega,
  elegant,
  energiebe,
  ecopower,
  bolt,
  octaplus,
  cociter,
  dats24,
}

export const PROVIDER_DATA = [
  { name: "engie", nl: true, fr: true, logo: logo_engie },
  { name: "luminus", nl: true, fr: true, logo: logo_luminus },
  { name: "eneco", nl: true, fr: true, logo: logo_eneco },
  { name: "total", nl: true, fr: true, logo: logo_total_energies },
  { name: "mega", nl: true, fr: true, logo: logo_mega },
  { name: "elegant", nl: true, fr: false, logo: logo_elegant },
  { name: "energiebe", nl: true, fr: false, logo: logo_energiebe },
  {
    name: "ecopower",
    nl: true,
    fr: false,
    logo: logo_ecopower,
  },
  { name: "bolt", nl: true, fr: true, logo: logo_bolt },
  { name: "octaplus", nl: true, fr: true, logo: logo_octaplus },
  {
    name: "cociter",
    nl: false,
    fr: true,
    logo: logo_cociter,
  },
  {
    name: "dats24",
    nl: false,
    fr: true,
    logo: logo_dats24,
  },
];

export type ProviderScore = {
  price: number;
  adjusted_formula: number;
  stable_price: number;
  origin: number;
  source: number;
  customer_satisfaction: number;
  invests_in_renewable: number;
};

// NOTE: This represents the data from seacoop-NL.csv + seacoop-FR.csv (2026-07-28)
// All percentages are written as floats between 0 and 1
export const NL_SCORES = {
  engie: {
    price: 0.3,
    adjusted_formula: 0.58,
    stable_price: 0.33,
    origin: 0.03,
    source: 0.0,
    customer_satisfaction: 0.73,
    invests_in_renewable: 0.02,
  },
  luminus: {
    price: 0.0,
    adjusted_formula: 0.67,
    stable_price: 0.67,
    origin: 0.51,
    source: 0.24,
    customer_satisfaction: 0.85,
    invests_in_renewable: 0.22,
  },
  eneco: {
    price: 0.28,
    adjusted_formula: 0.08,
    stable_price: 0.17,
    origin: 0.69,
    source: 1.0,
    customer_satisfaction: 0.65,
    invests_in_renewable: 1.0,
  },
  total: {
    price: 0.32,
    adjusted_formula: 0.25,
    stable_price: 0.33,
    origin: 0.37,
    source: 0.35,
    customer_satisfaction: 0.05,
    invests_in_renewable: 0.0,
  },
  mega: {
    price: 0.08,
    adjusted_formula: 1.0,
    stable_price: 1.0,
    origin: 0.18,
    source: 0.53,
    customer_satisfaction: 0.0,
    invests_in_renewable: 0.0,
  },
  elegant: {
    price: 0.33,
    adjusted_formula: 0.08,
    stable_price: 0.17,
    origin: 0.79,
    source: 0.37,
    customer_satisfaction: 0.81,
    invests_in_renewable: 0.0,
  },
  ecopower: {
    price: 1.0,
    adjusted_formula: 0.0,
    stable_price: 0.0,
    origin: 1.0,
    source: 1.0,
    customer_satisfaction: 1.0,
    invests_in_renewable: 1.0,
  },
  energiebe: {
    price: 0.88,
    adjusted_formula: 0.08,
    stable_price: 0.17,
    origin: 1.0,
    source: 1.0,
    customer_satisfaction: 0.95,
    invests_in_renewable: 0.0,
  },
  bolt: {
    price: 0.25,
    adjusted_formula: 0.67,
    stable_price: 0.33,
    origin: 1.0,
    source: 1.0,
    customer_satisfaction: 0.78,
    invests_in_renewable: 1.0,
  },
  octaplus: {
    price: 0.15,
    adjusted_formula: 0.42,
    stable_price: 0.33,
    origin: 0.0,
    source: 0.54,
    customer_satisfaction: 0.7,
    invests_in_renewable: 0.0,
  },
};

export const FR_SCORES = {
  engie: {
    price: 0.23,
    adjusted_formula: 0.46,
    stable_price: 0.29,
    origin: 0.04,
    source: 0.0,
    customer_satisfaction: 0.53,
    invests_in_renewable: 0.02,
  },
  luminus: {
    price: 0.0,
    adjusted_formula: 0.54,
    stable_price: 0.57,
    origin: 0.51,
    source: 0.24,
    customer_satisfaction: 0.59,
    invests_in_renewable: 0.22,
  },
  eneco: {
    price: 0.17,
    adjusted_formula: 0.08,
    stable_price: 0.14,
    origin: 0.69,
    source: 1.0,
    customer_satisfaction: 0.39,
    invests_in_renewable: 1.0,
  },
  total: {
    price: 0.19,
    adjusted_formula: 0.31,
    stable_price: 0.29,
    origin: 0.37,
    source: 0.35,
    customer_satisfaction: 0.21,
    invests_in_renewable: 0.0,
  },
  mega: {
    price: 0.1,
    adjusted_formula: 1.0,
    stable_price: 1.0,
    origin: 0.19,
    source: 0.53,
    customer_satisfaction: 0.07,
    invests_in_renewable: 0.0,
  },
  cociter: {
    price: 0.54,
    adjusted_formula: 0.0,
    stable_price: 0.0,
    origin: 1.0,
    source: 1.0,
    customer_satisfaction: 1.0,
    invests_in_renewable: 1.0,
  },
  bolt: {
    price: 0.08,
    adjusted_formula: 0.15,
    stable_price: 0.14,
    origin: 1.0,
    source: 1.0,
    customer_satisfaction: 0.55,
    invests_in_renewable: 1.0,
  },
  octaplus: {
    price: 0.2,
    adjusted_formula: 0.31,
    stable_price: 0.29,
    origin: 0.0,
    source: 0.54,
    customer_satisfaction: 0.0,
    invests_in_renewable: 0.0,
  },
  dats24: {
    price: 0.7,
    adjusted_formula: 0.0,
    stable_price: 0.0,
    origin: 1.0,
    source: 0.6,
    customer_satisfaction: 0.39,
    invests_in_renewable: 1.0,
  },
};

export const SCORES = {
  nl: NL_SCORES,
  fr: FR_SCORES,
  de: FR_SCORES,
};
